import React from 'react';
import H2HeaderText from '../ui/typography/H2HeaderText';
export default function FAQSection({ faqData }) {
  return (
    <section className="flex flex-col global-max-width-wrapper mx-auto my-24 gap-12 sm:flex-row">
      <div className="w-full">
        <H2HeaderText title="FAQs" fontWeight="text-regular" className="mb-5" />
        <ul className="flex flex-col gap-1 text-orange-500">
          {faqData?.map((faq, faqIndex) => (
            <li className="hover:text-gray-700 cursor-pointer hover:underline">
              <a href={`#faq-${faqIndex + 1}`}>{faq?.question?.text}</a>
            </li>
          ))}
        </ul>
      </div>
      <div>
        {faqData?.map((faq, faqIndex) => (
          <>
            <h3 id={`faq-${faqIndex + 1}`} className="text-blue-500 text-2xl text-medium mb-6">
              {' '}
              {faq?.question?.text}
            </h3>
            <div className="mb-8" dangerouslySetInnerHTML={{ __html: faq?.answer?.html }}></div>
          </>
        ))}
      </div>
    </section>
  );
}
